import { useQuery } from '@tanstack/react-query';
import {
  request,
  type V3ApiSuccessData,
  type V3ApiError,
} from 'javascripts/services/v3ApiClient';

export type GetReviewCountResponse = V3ApiSuccessData<{
  reviewRequestCount: number;
}>;

type UseGetReviewCountArgs = {
  reviewProfileId: number;
};

export const REVIEW_COUNT_QUERY_KEY = 'ReviewCount';

export const useGetReviewRequestCount = ({
  reviewProfileId,
}: UseGetReviewCountArgs) => {
  return useQuery<GetReviewCountResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: `companies/review_profiles/${reviewProfileId}/review_request_count`,
      });
      return response.data;
    },
    queryKey: [REVIEW_COUNT_QUERY_KEY, reviewProfileId],
  });
};
